import { Divider } from 'antd';
import React from 'react';
import HomeLogo from '../../component/HomeLogo';
import MenuList from '../../component/MenuList';
import Notification from '../../component/Notification';
import ProjectName from '../../component/ProjectName';
import { UserAction } from '../../component/User';
import './MenuBarContainer.scss';
import { PopupTaskAnalyzeProcessStatusContainer } from '@bvt-features/mapp/taskAnalyze/container/PopupTaskAnalyzeProcessStatusContainer';
import { useMap } from 'react-leaflet';

export default function MenuBarContainer() {
  const initialMap = useMap();

  return (
    <div
      className='menu-bar'
      onMouseEnter={() => {
        initialMap.dragging.disable();
        initialMap.scrollWheelZoom.disable();
        initialMap.doubleClickZoom.disable();
      }}
      onMouseLeave={() => {
        initialMap.dragging.enable();
        initialMap.scrollWheelZoom.enable();
        initialMap.doubleClickZoom.enable();
      }}
    >
      <div className='menu-bar__left'>
        <HomeLogo />
        <MenuList />
      </div>
      <div className='menu-bar__middle'>
        <ProjectName />
      </div>
      <div className='menu-bar__right'>
        <PopupTaskAnalyzeProcessStatusContainer />
        <Divider type='vertical' />
        <Notification />
        <UserAction />
      </div>
    </div>
  );
}
